module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/stat/chart.component.html
// module id = 437
// module chunks = 0